import { render, staticRenderFns } from "./r-reward-track-panel.vue?vue&type=template&id=18ad83b4"
import script from "./r-reward-track-panel.vue?vue&type=script&lang=js"
export * from "./r-reward-track-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ad83b4')) {
      api.createRecord('18ad83b4', component.options)
    } else {
      api.reload('18ad83b4', component.options)
    }
    module.hot.accept("./r-reward-track-panel.vue?vue&type=template&id=18ad83b4", function () {
      api.rerender('18ad83b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward/r-reward-track-panel.vue"
export default component.exports